import { createI18n } from 'vue-i18n'

// 导入所有语言文件
import zh from './locales/zh'
import en from './locales/en'
import fr from './locales/fr'
import ru from './locales/ru'
import es from './locales/es'
import it from './locales/it'
import pt from './locales/pt'
import ptBR from './locales/pt-br'

const messages = {
    zh,
    en,
    fr,
    ru,
    es,
    it,
    pt,
    'pt-br': ptBR
}

const getDefaultLanguage = () => {
    // 优先级 1：用户之前是否手动切换过语言（从 localStorage 读取）
    const cachedLang = localStorage.getItem('user-locale')
    if (cachedLang) {
        return cachedLang
    }

    // 优先级 2：获取浏览器默认语言 (例如返回 'zh-CN' 或 'en-US')
    const browserLang = navigator.language || navigator.userLanguage

    // 将其转换为前两个字母的小写进行粗略匹配 (例如 'zh-CN' 变成 'zh')
    const shortLang = browserLang.toLowerCase().substring(0, 2)

    // 判断我们系统是否支持该语言
    const supportedLangs = ['en', 'zh', 'fr', 'es', 'it', 'pt', 'pt-br'] // 你的支持列表
    if (supportedLangs.includes(shortLang)) {
        return shortLang
    }

    // 优先级 3：如果没有匹配到，默认返回英语
    return 'en'
}

const i18n = createI18n({
    legacy: false, // 必须设置为 false，才能在 Vue 3 Composition API 中使用
    locale: getDefaultLanguage(), // 动态设置初始语言
    fallbackLocale: 'en',
    messages,
})

export default i18n